import { CONVERSION_RATES } from '~/project-management/constants/pm-constants.js';

export function getTranslationMap($t) {
  return {
    wbs: $t('WBS'),
    status: $t('Status'),
    progress: $t('Progress'),
    total_slack: $t('Total slack'),
    free_slack: $t('Free slack'),
    duration: $t('Duration'),
  };
}

export function parseDuration(input) {
  let total_duration = 0;
  // Normalize input: remove spaces and convert to lowercase
  const normalized_input = input.replace(/\s+/g, '').toLowerCase();

  // Define regex pattern to match all duration types
  const pattern = /(?<value>\d+)(days*|weeks*|months*|years*|[dwmy])?/g;

  // Check if the input contains only a number
  if (/^\d+$/.test(normalized_input))
    return Number.parseInt(normalized_input) * CONVERSION_RATES.d;

  let match = pattern.exec(normalized_input);

  while (match !== null) {
    const value = match.groups.value || {};
    const unit = match[0];
    const regex = /[a-z]+/;
    const match_one = regex.exec(unit);
    const base_unit = match_one ? match_one[0] : null; // Default to 'd' if no unit is found
    if (base_unit)
      total_duration += Number.parseInt(value) * CONVERSION_RATES[base_unit];

    match = pattern.exec(normalized_input);
  }

  return total_duration || null;
}

export function generateUID() {
  let uid;
  do {
    uid = crypto.randomUUID().substring(0, 8);
  } while (/^\d+$/.test(uid));
  return uid;
}

export function getAutoSyncedActivities(activities, type) {
  return Object.values(activities || {}).filter(activity => activity.auto_progress_sync?.is_enabled
    && (!type || activity.auto_progress_sync.type === type));
}
